import type { LetterAddressWindow } from "../../../../../../../../../../../../api/kehrblatt/letters"

const defaults: LetterAddressWindow = {
  sender_left_mm: 20,
  sender_top_mm: 52,
  sender_width_mm: 85,
  sender_height_mm: 8,
  recipient_left_mm: 20,
  recipient_top_mm: 52,
  recipient_width_mm: 82,
  recipient_height_mm: 40,
}

export const resolveLetterAddressWindow = (value: unknown): LetterAddressWindow => {
  const raw =
    value && typeof value === "object" && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {}

  return Object.fromEntries(
    Object.entries(defaults).map(([key, fallback]) => {
      const parsed = Number(String(raw[key] ?? "").trim())

      return [key, Number.isFinite(parsed) && parsed > 0 ? parsed : fallback]
    }),
  ) as LetterAddressWindow
}
